<template>
  <utd-toast ref="toastRef"
             class="persistent-login-toast"
             position="top-right"
             has-variable-text="true"
             :message="`You are signed in as ${firstName} ${lastName}`"
             aria-live="polite" />
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import UtdToast from '_acaSrc/components/shared/stdlib/UtdToast.vue';
import { getCookie, setCookie } from '_acaSrc/utility/Cookies';

const BROWSER_SESSION_COOKIE = '_utd_bs';

const store = useStore();
const toastRef = ref(null);

const firstName = computed(() => store.getters['user/userFirstName'] || '');
const lastName = computed(() => store.getters['user/userLastName'] || '');

const shouldShowToast = computed(() =>
    store.getters['app/isAppDataLoaded']
        && store.getters['user/userLoggedIn']
        && store.getters['feature/isPersistentLoginEnabled']
);

const showToast = () => {
    if (!shouldShowToast.value) {
        return;
    }
    const isNewBrowserSession = !getCookie(BROWSER_SESSION_COOKIE);
    setCookie(BROWSER_SESSION_COOKIE, 'true', {
        path: '/',
        sameSite: 'None',
        secure: true
    });
    if (!isNewBrowserSession || getCookie('_utd_plq') !== 'true') {
        return;
    }
    toastRef.value?.show();
};

watch(shouldShowToast, showToast, { immediate: true });
</script>

<style lang="less" scoped>
.persistent-login-toast :deep(.utd-notification) {
  padding: 0.8rem 1rem 1rem 3.25rem;
}

.persistent-login-toast :deep(.utd-notification .utd-notification-content) {
  padding-right: 30px;

  span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
  }
}
</style>
